(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["box-overview"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  const collectionSearchMedia = window.matchMedia('(max-width: 749px)');
  const syncCollectionSearchPlaceholders = () => {
    document.querySelectorAll('[data-collection-responsive-placeholder]').forEach((input) => {
      input.placeholder = collectionSearchMedia.matches
        ? input.dataset.placeholderMobile
        : input.dataset.placeholderDesktop;
    });
  };
  syncCollectionSearchPlaceholders();
  collectionSearchMedia.addEventListener('change', syncCollectionSearchPlaceholders);
  document.addEventListener('shopify:section:load', syncCollectionSearchPlaceholders);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carousel-libri"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.carousel-libri').forEach((section) => {
    const track = section.querySelector('[data-carousel-track]');
    const getStep = () => {
      const card = track.querySelector('.carousel-libri__card');
      const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
      return (card?.getBoundingClientRect().width || 0) + gap;
    };
    section.querySelector('[data-carousel-prev]').addEventListener('click', () => {
      track.scrollBy({ left: -getStep() * 2, behavior: 'smooth' });
    });
    section.querySelector('[data-carousel-next]').addEventListener('click', () => {
      track.scrollBy({ left: getStep() * 2, behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-box"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  const collectionSearchMedia = window.matchMedia('(max-width: 749px)');
  const syncCollectionSearchPlaceholders = () => {
    document.querySelectorAll('[data-collection-responsive-placeholder]').forEach((input) => {
      input.placeholder = collectionSearchMedia.matches
        ? input.dataset.placeholderMobile
        : input.dataset.placeholderDesktop;
    });
  };
  syncCollectionSearchPlaceholders();
  collectionSearchMedia.addEventListener('change', syncCollectionSearchPlaceholders);
  document.addEventListener('shopify:section:load', syncCollectionSearchPlaceholders);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  const collectionSearchMedia = window.matchMedia('(max-width: 749px)');
  const syncCollectionSearchPlaceholders = () => {
    document.querySelectorAll('[data-collection-responsive-placeholder]').forEach((input) => {
      input.placeholder = collectionSearchMedia.matches
        ? input.dataset.placeholderMobile
        : input.dataset.placeholderDesktop;
    });
  };
  syncCollectionSearchPlaceholders();
  collectionSearchMedia.addEventListener('change', syncCollectionSearchPlaceholders);
  document.addEventListener('shopify:section:load', syncCollectionSearchPlaceholders);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-split"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.promo-split--catalog').forEach((section) => {
    const images = Array.from(section.querySelectorAll('[data-promo-collage] .promo-split__image--tile'));
    const rows = Array.from(section.querySelectorAll('[data-promo-row-index]'));
    const track = section.querySelector('[data-promo-mobile-track]');

    rows.forEach((row, index) => {
      const activate = () => images.forEach((image, imageIndex) => image.classList.toggle('is-active', imageIndex === index));
      row.addEventListener('mouseenter', activate);
      row.addEventListener('focus', activate);
    });

    section.querySelector('[data-promo-mobile-prev]')?.addEventListener('click', () => {
      track?.scrollBy({ left: -323, behavior: 'smooth' });
    });
    section.querySelector('[data-promo-mobile-next]')?.addEventListener('click', () => {
      track?.scrollBy({ left: 323, behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recensioni-diffusione"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.recensioni-diffusione').forEach((section) => {
    const track = section.querySelector('[data-rec-track]');
    const getStep = () => {
      const card = track.querySelector('.recensioni-diffusione__card');
      const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
      return (card?.getBoundingClientRect().width || 0) + gap;
    };
    section.querySelector('[data-rec-prev]').addEventListener('click', () => {
      track.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });
    section.querySelector('[data-rec-next]').addEventListener('click', () => {
      track.scrollBy({ left: getStep(), behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-media-text"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.story-media-text').forEach((section) => {
    const toggle = section.querySelector('[data-audio-toggle]');
    const audio = section.querySelector('[data-story-audio]');
    const video = section.querySelector('video');
    const media = audio || video;
    if (!toggle || !media) return;
    toggle.addEventListener('click', async () => {
      if (!media.paused) {
        media.pause();
        return;
      }
      if (video && !audio) video.muted = false;
      try { await media.play(); } catch { toggle.setAttribute('aria-pressed', 'false'); }
    });
    media.addEventListener('play', () => toggle.setAttribute('aria-pressed', 'true'));
    media.addEventListener('pause', () => toggle.setAttribute('aria-pressed', 'false'));
    media.addEventListener('ended', () => toggle.setAttribute('aria-pressed', 'false'));
  });

  } catch(e) { console.error(e); }
})();
})();
